import { Card, CardBody, Col, Container, Row, Table, Badge } from "reactstrap";
import Breadcrumbs from "../../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import apiRequestHelper from "../../../../utils/apiRequestHelper";
import { toast } from "react-toastify";
import { Btn } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import CenteredModal from "../../../Ui-Kits/Modal/CenteredModal/CenteredModal";

interface TagType {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  _count?: {
    blogTags: number;
  };
}

const TagCardsContainer = () => {
  const [tags, setTags] = useState<TagType[]>([]);
  const [selectedTagId, setSelectedTagId] = useState<number | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    try {
      setLoading(true);
      const response = await apiRequestHelper.get("/tags");
      setTags(response.data.data.tags);
    } catch (error: any) {
      toast.error(
        error.response?.data?.messages?.[0]?.message || "Failed to load tags"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSuccess = () => {
    setTags((prev) => prev.filter((tag) => tag.id !== selectedTagId));
  };

  const formatDate = (iso: string) => {
    if (!iso) return "-";
    const d = new Date(iso);
    return d.toLocaleDateString();
  };

  return (
    <>
      <Breadcrumbs mainTitle={"Tags"} parent={"Tags"} />

      <Container fluid>
        <Row className="mb-3">
          <Col>
            <Link to="/tags/add">
              <Btn color="primary">Add New Tag</Btn>
            </Link>
          </Col>
        </Row>

        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                {loading ? (
                  <div className="text-center">
                    <p className="mb-0">Loading tags...</p>
                  </div>
                ) : tags.length === 0 ? (
                  <div className="text-center">
                    <p className="mb-0">
                      No tags found. Create your first tag!
                    </p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table
                      bordered
                      hover
                      responsive
                      className="align-middle mb-0"
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "60px" }}>#</th>
                          <th>Name</th>
                          <th style={{ width: "140px" }}>Blogs</th>
                          <th style={{ width: "160px" }}>Created</th>
                          <th
                            style={{ width: "200px" }}
                            className="text-center"
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {tags.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>

                            <td>{item.name}</td>

                            <td>
                              <Badge color="success">
                                {item._count?.blogTags || 0} Blog(s)
                              </Badge>
                            </td>

                            <td>{formatDate(item.createdAt)}</td>

                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-2">
                                <Link to={`/tags/edit/${item.id}`}>
                                  <Btn className="btn-edit-custom">Edit</Btn>
                                </Link>

                                <Btn
                                  color="danger"
                                  onClick={() => {
                                    setSelectedTagId(item.id);
                                    setModalOpen(true);
                                  }}
                                >
                                  Delete
                                </Btn>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {selectedTagId !== null && (
        <CenteredModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          blogId={selectedTagId}
          url={"/tags"}
          onDeleteSuccess={handleDeleteSuccess}
        />
      )}
    </>
  );
};

export default TagCardsContainer;
